import { Details } from "~/entities/Details";

// BIK-2095: a one-line entry from the single main input — either pasted ("paste") or typed
// ("manual-single") — is verified via the UPS XAV "Region" mode. Segmented-field edits use
// "manual" and take the normal segmented path below.
export function isRegionEntry(stageDetail: Details): boolean {
  return (
    !!stageDetail?.rawInput &&
    (stageDetail?.inputMethod === "paste" ||
      stageDetail?.inputMethod === "manual-single")
  );
}

export default function (stageDetail: Details): string {
  // BIK-2095: send the one-line entry to the AVS endpoint via the `region` param (Region
  // mode). The backend ignores the segmented params in this mode, so we only send region +
  // country. country defaults to US (Region is US/PR only).
  if (isRegionEntry(stageDetail)) {
    const country =
      typeof stageDetail.country === "string"
        ? stageDetail.country
        : stageDetail.country?.code || "US";
    return new URLSearchParams({
      region: stageDetail.rawInput as string,
      country,
    }).toString();
  }
  const data = {
    company: stageDetail?.company ?? "",
    address1: stageDetail.streetAddress,
    address2: stageDetail?.address2 ?? "",
    city: stageDetail.city ?? "",
    state:
      typeof stageDetail.state === "string"
        ? stageDetail.state
        : stageDetail.state?.stateprovcode ?? "",
    postalCode: stageDetail.postalCode,
    country:
      typeof stageDetail.country === "string"
        ? stageDetail.country
        : stageDetail.country?.code ?? "",
  };
  const searchParams = new URLSearchParams(data);
  return searchParams.toString();
}
